module.exports = __webpack_public_path__ + "img/type--3-spans--single-lang--en.fd6cca4c.jpg";